<template>
	<el-dialog title="下载项管理" :visible.sync="dialogVisible" width="1000px" top="3%" :close-on-click-modal="false" @close="closeDialog">
		<el-form :model="firstRow" ref="ruleForm" label-width="80px" 
		         style="height: 72vh;overflow-y: auto;min-height: 300px;">
		   <el-row v-for="(item,idx) in DataList" :key="idx"> 
		   	<el-col :span="6">
				<el-form-item label="字段名称" prop="role_name">
				    <el-input size="small" v-model.trim="item.col_name" style="width: 100%"/>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="字段代码" prop="role_name">
				    <el-input size="small"  v-model.trim="item.col_code" style="width: 100%"/>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="排序号" prop="role_name">
				    <el-input size="small"  v-model.trim="item.sort" type="number" style="width: 100%"/>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-button circle size="small" icon="el-icon-check" @click="saveData(item)"></el-button>
				<el-button circle size="small" icon="el-icon-remove" @click="removeItem(item)"></el-button>
			</el-col>
			
		   </el-row>
		   
		</el-form>
		<el-row>
			<el-col :span="22" style="text-align: right;">
				<el-button size="small" type="default" @click="closeDialog">关闭</el-button>
				<el-button size="small" type="default" icon="el-icon-plus" @click="addNew">添加新项</el-button>
				
			</el-col>
		</el-row>


	</el-dialog>

</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: true,
				DataList:[],
				firstRow:{
					id:0,
					col_name:"",
					col_code:"",
					sort:"99"
					
				},
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			getList(){
				this.$http.post("/api/sys_role_down_item_list").then(res=>{
					this.DataList = res.data
					if(res.data.length==0){
						this.DataList.push({...(this.firstRow)})
					}
				})
			},
			addNew(){
				this.DataList.push({...(this.firstRow)})
			},
			saveData(item){
				item.pm_id=this.pmid;
				this.$http.post("/api/sys_role_down_item_edit",item).then(ok=>{
					this.$message.success('保存成功')
					
					this.getList()
				})
			},
			removeItem(item){
				if(item.id>0){
					this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$http.post("/api/sys_role_down_item_delete", {
							id: item.id
						}).then(res => {
							this.$message({
								type: 'success',
								message: '删除成功'
							});
					
							this.getList();
						})
					
					}).catch(() => {
					
					});
				}else{
					this.getList();
				}
				
			},
			closeDialog(){
				this.dialogVisible = false
				setTimeout(()=>{
					this.$parent.showRowItem = false
				},300)
				
			}
			
		},
	}
</script>

<style>
</style>
